import styles from './PlatformBackground.module.scss';

// Non-interactive motifs echo the voice and WhatsApp pages without covering copy.
export default function PlatformBackground({ motif = 'network', hero = false }) {
  return <div className={`${styles.detail} ${hero ? styles.hero : styles.section}`} aria-hidden="true">
    <svg className={styles.pluses} viewBox="0 0 220 180" fill="none" stroke="currentColor" strokeWidth="1.4" focusable="false">
      {[0,1,2,3].flatMap(row => [0,1,2,3,4].map(col => <path key={`${row}-${col}`} d={`M${17+col*44} ${22+row*44}h10m-5-5v10`}/>))}
    </svg>
    <svg className={styles.tiles} viewBox="0 0 260 180" fill="none" stroke="currentColor" strokeWidth="1" focusable="false">
      {[0,1,2].flatMap(row => [0,1,2,3,4].map(col => <rect key={`${row}-${col}`} x={col*52+1} y={row*52+1} width="40" height="40" rx="3"/>))}
    </svg>
    {motif !== 'grid' && <svg className={styles.motif} viewBox="0 0 560 360" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" focusable="false">
      {motif === 'chat' && <>
        <path d="M70 50h230a28 28 0 0 1 28 28v124a28 28 0 0 1-28 28H142l-64 48v-48h-8a28 28 0 0 1-28-28V78a28 28 0 0 1 28-28Z"/>
        <path d="M355 118h101a28 28 0 0 1 28 28v116a28 28 0 0 1-28 28h-2v44l-58-44H230a28 28 0 0 1-28-28"/>
        <path d="M97 105h166M97 133h118"/>
        {[117,151,185].map(cx => <circle key={cx} cx={cx} cy="179" r="4"/>)}
      </>}
      {motif === 'flow' && <>
        <rect x="48" y="124" width="78" height="78" rx="17"/>
        <path d="M126 163h75M267 163h49a24 24 0 0 0 24-24V85a24 24 0 0 1 24-24h35M267 163h49a24 24 0 0 1 24 24v54a24 24 0 0 0 24 24h35"/>
        <path d="m234 130 33 33-33 33-33-33 33-33Z"/>
        <rect x="399" y="28" width="72" height="66" rx="15"/><rect x="399" y="232" width="72" height="66" rx="15"/>
        <path d="M76 163h22m-11-11v22m338-163 7 7 13-14m-24 213h28"/>
      </>}
      {motif === 'support' && <>
        <path d="M60 64h212a24 24 0 0 1 24 24v126a24 24 0 0 1-24 24H120l-54 43v-43h-6a24 24 0 0 1-24-24V88a24 24 0 0 1 24-24Z"/>
        <circle cx="166" cy="123" r="21"/><path d="M125 190v-8a41 41 0 0 1 82 0v8M322 151h36m-10-10 10 10-10 10"/>
        <rect x="380" y="70" width="138" height="186" rx="22"/>
        <circle cx="449" cy="122" r="20"/><path d="m440 122 6 6 13-13M407 179h84M407 204h58"/>
      </>}
      {motif === 'network' && <>
        <rect x="222" y="136" width="92" height="92" rx="24"/>
        <path d="M222 182H128a24 24 0 0 1-24-24V98M268 136V80h131M314 182h104M268 228v49a24 24 0 0 0 24 24h79"/>
        <rect x="74" y="38" width="60" height="60" rx="15"/><rect x="399" y="50" width="60" height="60" rx="15"/>
        <circle cx="449" cy="182" r="30"/><rect x="371" y="271" width="60" height="60" rx="15"/>
        <path d="M253 182h30m-15-15v30M91 68h26M429 67v26m-13-13h26"/>
      </>}
    </svg>}
  </div>;
}
